<template>
  <vx-card
    title="Rating Masyarakat Terbaru"
    :subtitle="ratingTerbaru.periode + ' berdasarkan penilaian masyarakat secara langsung'"
    class="mb-8"
  >
    <global-wrapper
      :loading="loading"
      :loadingType="'avatar-three-line'"
      :loadingList="4"
      :scrollable="true"
      height="400px"
    >
      <div
        class="w-full flex items-star mb-3"
        v-for="(data, index) in ratingTerbaru.rating"
        :key="index"
      >
        <vs-avatar
          text=""
          :src="avatar(data.avatar)"
          class="mr-5"
          size="40px"
        ></vs-avatar>
        <div class="flex-1">
          <div class="font-bold mt-3">{{ data.nama_pemohon }}</div>
          <div class="font-base">{{ data.nama_izin }}</div>
          <div class="font-base text-grey mb-4">
            {{ data.tanggal | moment }}
          </div>
          <div class="font-base italic mb-4">" {{ data.ulasan }} "</div>
          <star-rating
            :star-size="20"
            :read-only="true"
            :rating="data.rating"
            :round-start-rating="false"
            :border-width="1"
            border-color="#d8d8d8"
            :rounded-corners="true"
            :star-points="[
              23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46,
              19, 31, 17,
            ]"
          ></star-rating>
        </div>
      </div>
    </global-wrapper>
  </vx-card>
</template>

<script>
import StarRating from 'vue-star-rating'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  components: {
    StarRating,
  },
  data() {
    return {
      loading: true,
    }
  },
  mounted() {
    this.fetchDataRatingTerbaru()
  },
  methods: {
    async fetchDataRatingTerbaru() {
      this.loading = true
      await this.$store.dispatch('dashboard/fetchDataRatingTerbaru')
      this.loading = false
    },
    avatar(path) {
      return path
    },
  },
  computed: {
    ...mapState({
      ratingTerbaru: (state) => state.dashboard.kinerja.ratingTerbaru,
    }),
  },
  filters: {
    moment: function (date) {
      return moment(date).locale('id').fromNow()
    },
  },
}
</script>